<template>
  <div
    class="qotd-card"
    :class="{ 'first': isFirst }"
    @click="$emit('click')"
  >
    <div class="first-row">
      <div v-if="isFirst" class="question">
        {{ qotd.question }}
      </div>
      <div class="icon-wrapper">
        <icon
          name="calendar-detailed"
          class="calendar-icon"
        ></icon>
        <icon
          v-if="hasFlashcardState"
          name="calendar-star"
          class="star-icon"
        ></icon>
      </div>
    </div>
    <div class="date">
      <div class="weekday">
        <icon
          v-if="rateLimitLocked && !isFirst"
          name="lock-slot"
        ></icon>
        <span>{{ dayOfTheWeek }}</span>
        <span v-if="isFirst">{{ monthAndDay }}</span>
      </div>
      <div :class="{ transparent: isFirst }" class="month-and-day">
        {{ monthAndDay }}
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@components/singletons/icon';

export default {
  name: 'QuestionOfTheDayCard',
  components: {
    Icon,
  },
  props: {
    qotd: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    rateLimitLocked: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['click'],
  computed: {
    date() {
      const date = new Date(this.qotd.date);
      const offset = date.getTimezoneOffset();
      date.setMinutes(date.getMinutes() + offset);
      return date;
    },
    dayOfTheWeek() {
      const weekday = this.date.toLocaleDateString('en-US', { weekday: 'long' });
      return this.isFirst ? weekday + ', ' : weekday;
    },
    monthAndDay() {
      return this.date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    },
    hasFlashcardState () {
      return this.qotd.flashcardState !== undefined;
    },
    isFirst() {
      return this.index === 0;
    },
  },
};
</script>

<style scoped lang="scss">
.qotd-card {
  background: #EFF4FF;
  border: 1px solid #8FADFF;
  border-radius: rem-calc(12);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  min-width: rem-calc(175);
  min-height: rem-calc(162);
  gap: rem-calc(20);
  padding-top: rem-calc(20);
  padding-bottom: rem-calc(13);
  cursor: pointer;

  &.first {
    min-width: rem-calc(372);
    align-items: flex-start;

    .date {
      padding-left: rem-calc(16);
      text-align: left;
    }
  }

  .first-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: rem-calc(16);
    padding: 0 rem-calc(16);
    height: rem-calc(60);

    .question {
      font-size: rem-calc(14);
      line-height: rem-calc(20);
      font-weight: 400;
      max-height: 60px;
      max-width: 17rem;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
  }

  .icon-wrapper {
    position: relative;
    min-width: rem-calc(48);
    min-height: rem-calc(48);
  }

  .calendar-icon {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .star-icon {
    position: absolute;
    top: 66%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .date {
    color: #101828;
    text-align: center;
  }

  .weekday {
    display: flex;
    gap: rem-calc(4);
    font-size: rem-calc(16);
    line-height: rem-calc(24);
    font-weight: 600;
  }

  .month-and-day {
    font-size: rem-calc(12);
    line-height: rem-calc(14);
    font-weight: 500;
  }

  .transparent {
    opacity: 0;
  }
}
</style>
